export const DOCK_TO_LEFT_ICON = 'dock_to_left';
export const DOCK_TO_LEFT_ICON_CLASS = 'material-symbols-outlined notranslate';
export const MATERIAL_ICON_CLASS = 'material-icons notranslate';

export function getDockControlIcon({ isDocked } = {}) {
  return isDocked ? 'open_in_new' : DOCK_TO_LEFT_ICON;
}

export function getDockControlIconClass({ isDocked } = {}) {
  return isDocked ? MATERIAL_ICON_CLASS : DOCK_TO_LEFT_ICON_CLASS;
}
